<script setup lang="ts">
import { ChevronRight, Plus } from 'lucide-vue-next'
import { useNavigationData } from '~~/src/composables/useNavigationData'
import Menu from '@/components/FloatMenu/indev.vue'
import CreateMenuContent from '@/components/CreateMenu/CreateMenuContent.vue'

interface Props {
  isOpen: boolean
}

defineProps<Props>()

defineOptions({
  name: 'CreateElementsMenu',
})

const { getCreateItems } = useNavigationData()
const createItems = getCreateItems()
</script>

<template>
  <div class="sidebar-menu">
    <Menu
      position="right"
      :offset="4"
    >
      <template #default="{ toggle }">
        <button
          type="button"
          class="create-button"
          :class="{ 'is-expanded': isOpen }"
          title="Create/Sell"
          @click.stop="toggle()"
        >
          <Plus :size="24" class="shrink-0" />
          <span
            v-if="isOpen"
            class="create-label"
          >Create/Sell</span>
          <ChevronRight
            v-if="isOpen"
            :size="24"
            class="chevron-icon"
          />
        </button>
      </template>

      <template #options>
        <CreateMenuContent :create-items="createItems" />
      </template>
    </Menu>
  </div>
</template>

<style lang="scss" scoped>
.sidebar-menu {
  @apply
    flex
    w-full
    min-w-0
    flex-col
}

.create-button {
  @apply
    flex
    items-center
    justify-center
    overflow-hidden
    outline-none
    transition-colors
    duration-200
    cursor-pointer
    rounded-full
    bg-[#21242C]
    text-white
    hover:bg-[#18181B]
    active:bg-[#18181B];

  width: 48px;
  height: 48px;
  padding: 12px;

  &.is-expanded {
    @apply
      justify-between
      w-full;
  }

  svg {
    @apply shrink-0;
  }
}

.create-label {
  @apply
    mx-4
    font-bold
    text-[16px]
    flex-1
    text-center;
}

.chevron-icon {
  @apply ml-auto;
}
</style>
